import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AuthGoogleService } from '../services/auth-google.service';
import { Router } from '@angular/router';
import { AuthAppleService } from '../services/auth-apple.service';
import { AuthVkService } from '../services/auth-vk.service';
import { AccountService } from '../services/account';

const MODULES: any[] = [
  MatButtonModule,
  MatIconModule,
  MatFormFieldModule,
  FormsModule,
  ReactiveFormsModule,
];

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [MODULES],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css',
})
export class LoginComponent {
  constructor(private router: Router) {
    this.getAppConfig();
  }

  private authGoogleService = inject(AuthGoogleService);
  private authAppleService = inject(AuthAppleService);
  private authVkService = inject(AuthVkService);
  private accountService = inject(AccountService);
  public isAgreementChecked: boolean = false;
  public appConfig: AppConfig = {} as AppConfig;
  private changeDetectorRef = inject(ChangeDetectorRef);

  public signInWithGoogle() {
    this.authGoogleService.login();
  }

  public signInWithApple() {
    this.authAppleService.login();
  }

  public signInWithVK() {
    this.authVkService.login();
  }

  public signInWithEmail() {
    this.router.navigate(["email-auth"]);
  }

  public onAgreementChange() {
  }

  private getAppConfig() {
    this.accountService.getAppConfig().subscribe({
      next: (data) => {
        this.appConfig = data.authConfig;
        this.changeDetectorRef.markForCheck();
      }
    })
  }
}
